var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStamp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "470px",
    height: "180px",
    viewBox: "139 210 30 35",
    id: "svg17332",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs17329"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19092"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#074e9c",
      strokeWidth: 1.17288,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect294183-7",
    width: 74.136726,
    height: 24.246552,
    x: 115.71529,
    y: 212.41158
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\u0420\\u0415\\u0426\\u0415\\u041F\\u0422 \\u041D\\u0415\\u0414\\u0415\\u0419\\u0421\\u0422\\u0412\\u0418\\u0422\\u0415\\u041B\\u0415\\u041D",
    id: "text107154",
    style: {
      fontSize: "7.05556px",
      lineHeight: 1.25,
      fontFamily: "Roboto",
      InkscapeFontSpecification: "Roboto",
      display: "inline",
      fill: "#074e9c",
      strokeWidth: 0.264583
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 140.63237,220.17128 v 1.76733 h -1.03353 v -5.01606 h 1.95682 q 0.56499,0 0.99219,0.20671 0.43063,0.2067 0.66146,0.58911 0.23082,0.37896 0.23082,0.86472 0,0.73725 -0.50643,1.16444 -0.50299,0.42375 -1.39527,0.42375 z m 0,-0.83716 h 0.92329 q 0.40997,0 0.62356,-0.19293 0.21704,-0.19292 0.21704,-0.55121 0,-0.36863 -0.21704,-0.596 -0.21704,-0.22738 -0.59945,-0.23427 h -0.9474 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 147.16772,219.76476 h -1.98437 v 1.34359 h 2.32888 v 0.83026 h -3.36241 v -5.01606 h 3.35552 v 0.83716 h -2.32199 v 1.19545 h 1.98437 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 148.07378,216.92255 h 1.03353 v 4.1858 h 2.00849 v -4.1858 h 1.03698 v 4.1858 h 0.68557 l -0.0689,2.03949 h -0.96463 v -1.20923 h -3.73104 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 156.49016,219.76476 h -1.98438 v 1.34359 h 2.32889 v 0.83026 h -3.36242 v -5.01606 h 3.35553 v 0.83716 h -2.322 v 1.19545 h 1.98438 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 161.52689,221.93861 h -1.03697 v -4.1789 h -2.0085 v 4.1789 h -1.03353 v -5.01606 h 4.079 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.20878,217.75971 h -1.53652 v 4.1789 h -1.03352 v -4.1789 h -1.51585 v -0.83716 h 4.08589 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 125.43777,230.75806 h -1.03353 v -2.14974 h -2.01538 v 2.14974 h -1.03353 V 225.742 h 1.03353 v 2.03261 h 2.01538 V 225.742 h 1.03353 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 129.35829,228.58421 h -1.98438 v 1.34359 h 2.32889 v 0.83026 h -3.36242 V 225.742 h 3.35553 v 0.83716 h -2.322 v 1.19545 h 1.98438 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.96002,231.99141 h -0.95429 v -1.23335 h -3.0248 v 1.2299 h -0.97841 l -0.0551,-2.06016 h 0.37896 q 0.30662,-0.25494 0.47198,-0.74759 0.16881,-0.49609 0.22738,-1.22646 l 0.14469,-2.21175 h 3.28662 v 4.1858 h 0.58567 z m -3.44854,-2.06361 h 1.91203 v -3.34864 h -1.27125 l -0.0861,1.31947 q -0.10336,1.32637 -0.55466,2.02917 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 138.60149,228.58421 h -1.98438 v 1.34359 h 2.32889 v 0.83026 h -3.36242 V 225.742 h 3.35553 v 0.83716 h -2.322 v 1.19545 h 1.98438 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142.5599,225.742 h 1.03698 v 5.01606 h -1.03698 v -3.33141 l -2.00849,3.33141 h -1.03353 V 225.742 h 1.03353 v 3.3383 z m 0.19982,-1.31947 q 0,0.4582 -0.33073,0.7407 -0.32728,0.28249 -0.86127,0.28249 -0.53399,0 -0.86472,-0.27905 -0.32729,-0.27905 -0.32729,-0.74414 h 0.70625 q 0,0.21704 0.12747,0.33762 0.13091,0.11713 0.35829,0.11713 0.22393,0 0.3514,-0.11713 0.12747,-0.12058 0.12747,-0.33762 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 148.43035,229.08719 q -0.0586,0.8096 -0.59945,1.27469 -0.53743,0.46509 -1.41938,0.46509 -0.96462,0 -1.51928,-0.64768 -0.55122,-0.65113 -0.55122,-1.78456 v -0.30662 q 0,-0.72347 0.25494,-1.27468 0.25493,-0.55122 0.72691,-0.84405 0.47543,-0.29628 1.10243,-0.29628 0.86817,0 1.39871,0.46509 0.53055,0.46509 0.61323,1.30569 h -1.03353 q -0.0379,-0.48576 -0.27216,-0.7028 -0.23082,-0.22049 -0.70625,-0.22049 -0.51676,0 -0.77514,0.37207 -0.25494,0.36863 -0.26183,1.14722 v 0.37896 q 0,0.81305 0.2446,1.18856 0.24805,0.37552 0.77859,0.37552 0.47887,0 0.71314,-0.21704 0.23771,-0.22049 0.27216,-0.67869 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.76773,226.57916 h -1.53651 v 4.1789 h -1.03353 v -4.1789 h -1.51585 V 225.742 h 4.08589 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153.35684,230.75806 V 225.742 h 1.757 q 0.91295,0 1.38493,0.3514 0.47198,0.34796 0.47198,1.0232 0,0.36862 -0.18948,0.65112 -0.18948,0.27905 -0.5271,0.40997 0.38585,0.0965 0.60633,0.38929 0.22393,0.29284 0.22393,0.71658 0,0.72347 -0.46164,1.09554 -0.46164,0.37207 -1.31603,0.37896 z m 1.03353,-2.18419 v 1.35393 h 0.88539 q 0.36518,0 0.56844,-0.17226 0.20671,-0.1757 0.20671,-0.48231 0,-0.68902 -0.71314,-0.69936 z m 0,-0.73036 h 0.76481 q 0.78204,-0.0138 0.78204,-0.62356 0,-0.34107 -0.19982,-0.48921 -0.19637,-0.15158 -0.62356,-0.15158 h -0.72347 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160.86716,225.742 h 1.03697 v 5.01606 h -1.03697 v -3.33141 l -2.0085,3.33141 h -1.03353 V 225.742 h 1.03353 v 3.3383 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.54812,226.57916 h -1.53651 v 4.1789 h -1.03353 v -4.1789 h -1.51585 V 225.742 h 4.08589 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 170.15514,228.58421 h -1.98438 v 1.34359 h 2.32889 v 0.83026 h -3.36242 V 225.742 h 3.35553 v 0.83716 h -2.322 v 1.19545 h 1.98438 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 175.18498,225.742 v 5.01606 h -1.03697 v -4.1789 h -1.3367 l -0.0827,1.77078 q -0.0517,0.89573 -0.22738,1.41249 -0.1757,0.51332 -0.51332,0.75448 -0.33762,0.23771 -0.92329,0.24115 h -0.26871 v -0.83026 l 0.17225,-0.0172 q 0.3893,-0.0517 0.55466,-0.44786 0.16881,-0.39963 0.2136,-1.41938 l 0.0861,-2.30133 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 179.1055,228.58421 h -1.98438 v 1.34359 h 2.32889 v 0.83026 h -3.36242 V 225.742 h 3.35553 v 0.83716 h -2.322 v 1.19545 h 1.98438 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 184.13879,230.75806 h -1.03353 v -2.14974 h -2.01538 v 2.14974 h -1.03353 V 225.742 h 1.03353 v 2.03261 h 2.01538 V 225.742 h 1.03353 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path19049"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamp4);
export default __webpack_public_path__ + "static/media/Stamp4.7fe6ff609ee213303c2956ecdcb9dd74.svg";
export { ForwardRef as ReactComponent };